<template>
  <div class="success-container">
    <van-notice-bar
      class="success-container-notice"
      color="#666666;"
      background="#FFFFFF;"
      left-icon="info-o"
    >
      建议唤起订阅时勾选，总是保持以上选择，不再询问
    </van-notice-bar>
    <div class="success-container-card">
      <van-image
        round
        class="success-container-card-img"
        :src="successImgUrl"
      />
      <h2 class="success-container-card-title">已绑定成功</h2>

      <div class="success-container-card-body">
        <h2 class="success-container-card-word">绑定服务号能干什么？</h2>
        <p style="font-size: 18px" class="success-container-card-body-text">
          <van-icon name="success" /><span
            >实现在微信同一主体下的不同程序，免登</span
          >
        </p>
        <p style="font-size: 18px" class="success-container-card-body-text">
          <van-icon name="success" /><span>接收重要平台通知</span>
        </p>
        <p style="font-size: 18px" class="success-container-card-body-text">
          <van-icon name="success" /><span
            >通过服务号下发的订阅消息，及时处理业务</span
          >
        </p>
      </div>
    </div>
    <div class="success-container-card">
      <div style="text-align: left">
        <div
          style="
            margin: 0px 10px;
            border-bottom: 1px solid #f3f3fa;
            padding: 5px 0px;
          "
        >
          <van-image
            class="success-container-card-headericon"
            :src="intellegentUrl"
          />
          <span class="success-container-card-message">平台通知</span>
        </div>
      </div>
      <!-- <van-cell class="success-container-card-notice">
        <template #icon>
          <van-image class="success-container-card-lefticon" :src="iconUrl" />
        </template>
        <template #title>
          <h5 class="success-container-card-h5">学校公告通知</h5>
          <p class="success-container-card-p">
            适用于所有用户：微信、PC发起移动协同 消息查看提醒
          </p>
        </template>
        <template #right-icon>
          <subButton
            launchId="school"
            template="FpQSJbQKJ6sxzEfra8XCPSCHQIGzXn8l34S-oSjtViE"
          ></subButton>
        </template>
      </van-cell> -->
      <van-cell class="success-container-card-notice">
        <template #icon>
          <van-image class="success-container-card-lefticon" :src="iconUrl" />
        </template>
        <template #title>
          <h5 class="success-container-card-h5">事务进度提醒</h5>
          <p class="success-container-card-p">学生采集计划发布通知</p>
        </template>
        <template #right-icon>
          <!-- <subButton
            launchId="student"
            template="X1FwZYbQM99fNCgeRw7h_a3jYXlDg-8GThhWjFb28II"
          ></subButton> -->
        </template>
      </van-cell>
      <van-cell class="success-container-card-notice">
        <template #icon>
          <van-image class="success-container-card-lefticon" :src="iconUrl" />
        </template>
        <template #title>
          <h5 class="success-container-card-h5">任务处理通知</h5>
          <p class="success-container-card-p">
            微信、PC发起的移动协同通知查看提醒
          </p>
        </template>
        <template #right-icon> </template>
      </van-cell>
      <van-cell class="success-container-card-notice">
        <template #icon>
          <van-image class="success-container-card-lefticon" :src="iconUrl" />
        </template>
        <template #title>
          <h5 class="success-container-card-h5">信息采集审核提醒</h5>
          <p class="success-container-card-p">
            学生信息中心-学生自主变更审核通知
          </p>
        </template>
        <template #right-icon> </template>
      </van-cell>
      <van-cell class="success-container-card-notice">
        <template #icon>
          <van-image class="success-container-card-lefticon" :src="iconUrl" />
        </template>
        <template #title>
          <h5 class="success-container-card-h5">档案信息变更审核通过通知</h5>
          <p class="success-container-card-p">
            学生信息中心-学生自主变更审核通过通知
          </p>
        </template>
        <template #right-icon> </template>
      </van-cell>
      <van-cell class="success-container-card-notice">
        <template #icon>
          <van-image class="success-container-card-lefticon" :src="iconUrl" />
        </template>
        <template #title>
          <h5 class="success-container-card-h5">用户绑定通知</h5>
          <p class="success-container-card-p">告知用户是否成功绑定</p>
        </template>
        <template #right-icon> </template>
      </van-cell>
    </div>
    <div class="success-container-card">
      <div style="text-align: left">
        <div
          style="
            margin: 0px 10px;
            border-bottom: 1px solid #f3f3fa;
            padding: 5px 0px;
          "
        >
          <van-image
            class="success-container-card-headericon"
            :src="intellegentUrl"
          />
          <span class="success-container-card-message">业务通知</span>
        </div>
      </div>
      <van-cell class="success-container-card-notice">
        <template #icon>
          <van-image class="success-container-card-lefticon" :src="iconUrl" />
        </template>
        <template #title>
          <h5 class="success-container-card-h5">学生请假未归通知</h5>
          <p class="success-container-card-p">请销假-学生请假未归通知</p>
        </template>
        <template #right-icon>
          <!-- <subButton
            launchId="student"
            template="X1FwZYbQM99fNCgeRw7h_a3jYXlDg-8GThhWjFb28II"
          ></subButton> -->
        </template>
      </van-cell>
      <van-cell class="success-container-card-notice">
        <template #icon>
          <van-image class="success-container-card-lefticon" :src="iconUrl" />
        </template>
        <template #title>
          <h5 class="success-container-card-h5">请假审批成功通知</h5>
          <p class="success-container-card-p">请销假-请假审批成功通知</p>
        </template>
        <template #right-icon> </template>
      </van-cell>
      <van-cell class="success-container-card-notice">
        <template #icon>
          <van-image class="success-container-card-lefticon" :src="iconUrl" />
        </template>
        <template #title>
          <h5 class="success-container-card-h5">放假通知</h5>
          <p class="success-container-card-p">请销假-放假通知</p>
        </template>
        <template #right-icon> </template>
      </van-cell>
      <van-cell class="success-container-card-notice">
        <template #icon>
          <van-image class="success-container-card-lefticon" :src="iconUrl" />
        </template>
        <template #title>
          <h5 class="success-container-card-h5">请假审批提醒</h5>
          <p class="success-container-card-p">请销假-请假审批提醒</p>
        </template>
        <template #right-icon> </template>
      </van-cell>
      <van-cell class="success-container-card-notice">
        <template #icon>
          <van-image class="success-container-card-lefticon" :src="iconUrl" />
        </template>
        <template #title>
          <h5 class="success-container-card-h5">学生到校通知</h5>
          <p class="success-container-card-p">疫情防控-学生到校通知</p>
        </template>
        <template #right-icon> </template>
      </van-cell>
      <van-cell class="success-container-card-notice">
        <template #icon>
          <van-image class="success-container-card-lefticon" :src="iconUrl" />
        </template>
        <template #title>
          <h5 class="success-container-card-h5">体温测量通知</h5>
          <p class="success-container-card-p">疫情防控-体温测量通知</p>
        </template>
        <template #right-icon> </template>
      </van-cell>
      <van-cell class="success-container-card-notice">
        <template #icon>
          <van-image class="success-container-card-lefticon" :src="iconUrl" />
        </template>
        <template #title>
          <h5 class="success-container-card-h5">学生发烧提醒</h5>
          <p class="success-container-card-p">疫情防控-学生发烧提醒</p>
        </template>
        <template #right-icon> </template>
      </van-cell>
      <van-cell class="success-container-card-notice">
        <template #icon>
          <van-image class="success-container-card-lefticon" :src="iconUrl" />
        </template>
        <template #title>
          <h5 class="success-container-card-h5">实时补助提醒</h5>
          <p class="success-container-card-p">临时困难补助-实时补助提醒</p>
        </template>
        <template #right-icon> </template>
      </van-cell>
    </div>
    <Sticky position="bottom" :offset-bottom="0">
      <div class="success-container-out">
        <van-button
          color="linear-gradient(to right, #1890ff, #5c7efa)"
          size="large"
          style="font-size: 15px"
          v-if="isApp"
          @click="redirectToWechat"
          >跳转到小程序</van-button
        >
        <wxButton
          v-else
          launchId="wxApp"
          username="gh_b8c95e7f6e70"
          :path="path"
        />
        <van-button
          color="linear-gradient(to right, #ff6034, #ee0a24)"
          size="large"
          style="font-size: 15px"
          @click="onHandleCancal"
          >取消绑定&退出登录</van-button
        >
      </div>
    </Sticky>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'
import wxButton from '@/components/wxButton'
import request from '@/utils/request'
import { Sticky } from 'vant'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const wx = require('weixin-js-sdk')
export default defineComponent({
  name: 'bindSuccess',
  components: {
    wxButton,
    Sticky
  },
  setup() {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const successImgUrl = require('@/assets/sucess/success.png')
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const iconUrl = require('@/assets/sucess/icon.png')
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const intellegentUrl = require('@/assets/sucess/intelligent.png')
    const baseUrl = window.location.href.split('#')[0]
    const isApp = ref(false)
    const path = ref('pages/start/start')
    const LoginUser = () => {
      request({
        url: `/wxapp/getWxConfig`,
        data: { url: baseUrl },
        params: null,
        method: 'post'
      }).then((configRes: any) => {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: configRes.appId,
          timestamp: configRes.timestamp, // 必填，生成签名的时间戳
          nonceStr: configRes.nonceStr, // 必填，生成签名的随机串
          signature: configRes.signature, // 必填，签名
          jsApiList: ['onMenuShareAppMessage', 'addEventListener'],
          openTagList: ['wx-open-subscribe', 'wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
        })
        wx.ready(function () {
          console.log('ready')
          // window.open('https://'+host+'/h5/#/pages/message/index/index')
        })
        wx.error((res: any) => {
          console.log('wx.error', res)
        })
      })
    }

    onMounted(() => {
      const ua: any = navigator.userAgent.toLowerCase()
      if (ua && ua.match(/MicroMessenger/i) == 'micromessenger') {
        wx.miniProgram.getEnv((res: any) => {
          if (res.miniprogram) {
            console.log('在小程序里')
            // wx.miniProgram.redirectTo({
            //   url: '/pages/login/login'
            // })
            isApp.value = true
          } else {
            console.log('在公众号里')
            request({
              url: `/getUserInfo`,
              params: null,
              method: 'get'
            }).then((res1: any) => {
              const sn = res1.data.sn
              path.value = `${path.value}?sn=${sn}`
            })
          }
        })
      } else {
        console.log('不在微信里')
      }
      LoginUser()
    })
    const redirectToWechat = () => {
      wx.miniProgram.redirectTo({
        url: '/pages/login/login'
      })
    }

    const onHandleCancal = () => {
      console.log('1111')
      request({
        url: '/wxapp/xd/user/cancelBind',
        method: 'POST'
      }).then(res => {
        if (res.status) {
          window.location.href = res.data as string
        }
      })
    }
    return {
      successImgUrl,
      iconUrl,
      intellegentUrl,
      isApp,
      redirectToWechat,
      onHandleCancal,
      path
    }
  }
})
</script>
<style lang="scss" scoped >
.success-container {
  background-color: #f3f3fa;
  width: 100vw;
  overflow-x: hidden;
  height: 100vh;
  &-notice {
    width: 750px;
    height: 61px;
    background: #ffffff;
    font-family: PingFang SC;
    font-size: 20px;
    color: #666666;
    &::v-deep {
      .van-icon-info-o {
        color: #ffbb62;
        font-size: 15px;
        padding: 4px 4px 4px 8px;
      }
    }
  }
  &-card {
    background-color: #ffffff;
    text-align: center;
    padding: 20px 0px;
    margin: 20px 0px;
    &-img {
      margin-top: 50px;
      width: 116px;
      height: 116px;
    }
    &-title {
      font-size: 35px;
      font-family: PingFang SC;
      font-weight: normal;
      color: #333333;
      margin: 10px 0px 30px 0px;
    }
    &-lefticon {
      height: 48px;
      width: 48px;
    }
    &-h5 {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
      line-height: 48px;
      padding-left: 20px;
    }
    &-p {
      height: 45px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 26px;
      padding-left: 20px;
      padding-top: 10px;
    }
    &-notice {
      text-align: left;
      border-bottom-color: #ffffff;
      display: flex;
      align-items: center;
      padding-left: 20px;
    }
    &-headericon {
      height: 32px;
      width: 32px;
      margin-right: 10px;
    }
    &-message {
      font-size: 30px;
      line-height: 52px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
      line-height: 48px;
    }
    &-body {
      text-align: left;
      padding: 0px 20px;
      &-text {
        color: #666666;
        font-size: 26px;
        margin: 20px 0px;
        span {
          margin-left: 20px;
        }
        &::v-deep {
          .van-icon-success {
            color: #396afc;
            font-size: 14px;
          }
        }
      }
    }
    &-word {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
    }

    &-icon {
      width: 60px;
      height: 58px;
    }
  }
  &-out {
    width: 100vw;
    text-align: center;
    height: 12vh;
    display: flex;
    background-color: rgba(255, 255, 255, 0.8);
    align-content: center;
    align-items: center;
    justify-content: space-around;
    button {
      width: 40vw;
      height: 80px;
      box-shadow: 0px 2px 8px 0px rgba(11, 37, 113, 0.3);
      border-radius: 12px;
      margin: 10px 0px;
    }
  }
}
.jumpApp {
  /* top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: transparent; */
}
.btnBox {
  padding: 40px 50px;
}
.subscribe-btn {
  background-color: #5c7efa;
  color: #fff;
  width: 60px;
  text-align: center;
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
  display: block;
}
</style>
